import React from "react";
import {useSelector} from "react-redux";

export default function PaySimpleTransactionFee() {
  const { organization, paymentInfo } = useSelector(state => state)
  const { pay_simple_fees } = paymentInfo

  const isApplyingFees = () => {
    if (organization.payment_processor !== "paysimple") {
      return false
    }
    return pay_simple_fees.organizations.includes(organization.name)
  }

  if (!isApplyingFees()) {
    return null
  }

  return (
    <div className={'pb-2'}>
      <div className={'text-black font-weight-bold'}>{pay_simple_fees.fees['CARD']['PERCENTAGE'] * 100}% + ${pay_simple_fees.fees['CARD']['FIXED']}0 Transaction fee will be applied for credit card payments</div>
      <div className={'text-black font-weight-bold'}>{pay_simple_fees.fees['BANK_ACCOUNT']['PERCENTAGE'] * 100}% + ${pay_simple_fees.fees['BANK_ACCOUNT']['FIXED']}0 Transaction fee will be applied for ACH payments</div>
    </div>
  );
}
